export default "__VITE_ASSET__CQSqhgR1__"